import { UserManager, WebStorageStateStore } from "oidc-client";
import Vue from "vue";
import VueCookie from "vue-cookie";
import axios from 'axios';
import router from "../router/index";

const COOKIE_FIELD_VALUE_STRING = 'value=';

export function createAuthServiceGa(serviceConfig) {

  const userAuth = new Vue({
    data() {
      return {
        user: {
          username: "",
          firstname: "",
          lastname: "",
          branchCode: "",
          isAuthenticated: false,
          gaFunctions: []
        }
      };
    },
    methods: {
      async refreshUserInfo() {
        //console.log("refreshuserinfo");
        let appCode = process.env.VUE_APP_CLIENTID;
        
        let token = getTokenFromCookie();
        
        if (!token) {
          //console.log("token doesn't exist");
          this.user.isAuthenticated = false;
          router.push({ name: "unauthorized" });
          //console.log("redirect to unauthorized");
          return;
        }
        // else
        //   console.log("token exists", token);

        if (tokenIsExpired(token)) {
          await fetch(`${process.env.VUE_APP_GLOBALAUTH_API}Login/RefreshToken/${token}`,)
            .then(async response => {
              const newToken = await response.json();
              //console.log("tokendata", newToken);

              if (!response.ok) {
                const error = (newToken && newToken.message) || response.statusText;
                //console.log("error", error);
                this.user.isAuthenticated = false;
                router.push({ name: "unauthorized" });
                return;
              }
              else {
                refreshToken(newToken);
                token = newToken;
              }              
            })
            .catch((err) => {
              //console.log(err);
              this.user.isAuthenticated = false;
              router.push({ name: "unauthorized" });
              return;
            });
        }

        //console.log("new token", token);
        var globalauth_session = sessionStorage.getItem("GlobalAuthUser");
        //console.log("globalauth_session", JSON.parse(globalauth_session));
        if (!globalauth_session) {
          //console.log("global auth session empty", this.user);
          await fetch(`${process.env.VUE_APP_GLOBALAUTH_API}Login/GetUserDataNew/${token}/${appCode}`,)
            .then(async response => {
              const data = await response.json();
              //console.log("data", data, "response", response);
              // check for error response
              if (!response.ok) {
                // get error message from body or default to response statusText
                const error = (data && data.message) || response.statusText;
                //console.log("error", error, "user", this.user);
                this.user.isAuthenticated = false;
                router.push({ name: "unauthorized" });
                return;
              }
              else {
                this.user.username = data.username;
                this.user.branchCode = data.branchCode;
                this.user.firstname = data.firstName;
                this.user.lastname = data.lastName;
                this.user.isAuthenticated = true;
                this.user.gaFunctions = data.functions;

                //console.log("user data", data, this.user);
                sessionStorage.setItem("GlobalAuthUser", JSON.stringify(this.user));
              }
            })
            .catch(error => {
              this.user.isAuthenticated = false;
              router.push({ name: "unauthorized" });
            });
        }
        else {
          //console.log("session is already present", JSON.parse(globalauth_session));
          this.user = JSON.parse(globalauth_session);
        }
      },
      async canRead(funcName) {
        //console.log("user", this.user);
        if (this.user && this.user.gaFunctions.length > 0) {
          let f = this.user.gaFunctions.filter(x => x.Name == funcName);
          if (f.length > 0 && f[0].Read)
            return true;
        }
        return false;
      },

      async canWrite(funcName) {

        if (this.user && this.user.gaFunctions.length > 0) {
          let f = this.user.gaFunctions.filter(x => x.Name == funcName);
          if (f.length > 0 && f[0].Write)
            return true;
        }
        return false;
      },

      async authenticate(returnPath) {
        await this.refreshUserInfo();
      },
    }
  });

  return userAuth;
}

var getTokenFromCookie = function () {
  const cookieValue = VueCookie.get('GlobalAuthUser');

  if (cookieValue) {
    const token = cookieValue
      .split('&')
      .find(s => s.indexOf(COOKIE_FIELD_VALUE_STRING) > -1)
      .replace(COOKIE_FIELD_VALUE_STRING, '');
    return token;
  }
  return '';

};


var refreshToken = function (token) {
  const cookieValue = VueCookie.get('GlobalAuthUser');
  //console.log("refreshed token", token);
  const GACookie = cookieValue.split('&');
  if (GACookie) {
    GACookie[0] = COOKIE_FIELD_VALUE_STRING + token;

    const newCookie = GACookie.join('&');

    var currentDomain = window.location.hostname.split('.').reverse().slice(0,2).reverse().join(".");

    document.cookie = `GlobalAuthUser=${newCookie};domain=${currentDomain};expires=${now.toUTCString()};path=/`;
  }
};

var tokenIsExpired = function (token) {
  var ticks = atob(token).split(':')[2];
  
  var ticksnow = ((Date.now() * 10000) + 621355968000000000);
  
  let refreshtoken = ticksnow > ticks; 

  //console.log("must refresh token", refreshtoken);

  return refreshtoken;

};